import React from 'react';
import { NavLink } from 'react-router-dom';

const AddSubCategoryCrumb = () => (
  <NavLink to="/admin/sub-categories/add">Add Sub Category</NavLink>
);

export default AddSubCategoryCrumb;
